import React, {Component} from 'react'
import { connect } from "react-redux";
import MyTable from "../../../../components/TableComponents/Table";
import {BsFillDropletFill} from "react-icons/bs";
import {RiPlantLine} from "react-icons/ri";
import {AiFillWarning} from "react-icons/ai";
import {BiDotsVertical} from "react-icons/bi";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {history} from "../../../../utils/history";


import {
    cleanPatient,
    deletePatient,
    editPatientData,
    filterPatientsTable, setPatientLockedStatus,
    setPatientsData
} from "../../../../redux/actions/Tabs-Actions";
import {setPatientsDataSelection} from "../../../../redux/actions/Doctor-Actions";
import AlertConfirm from "../../../../components/modals/Confirm";
import doctorApi from "../../../../services/ApiServices/doctorApi";
import SvGraphics from "../../../../assets/SvGraphics";
// import {adminApi} from "../../../services/ApiService";
// import AlertConfirm from "../../../components/modals/Confirm";
// import VersionEditForm from "../../../components/version/VersionEditForm";
// import {makeError} from "../../../components/modals/ErrorModal";
// import SVGIcons from "../../../assets/SVGIcons";


class PatientTableComposed extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visibleCollection: [],
            filteredCollection: [],
            isMore: false,
        }
    }

    deletePatient = async (patient) => {
        let {t} = this.props
        let confirm = await AlertConfirm({
            options: {
                extraMessage: t('hcp.patient.table.action_cannot_be_undone'),
                title: t('hcp.patient.table.del_patient'),
                warningRed: true
            }
        }, `${t('hcp.patient.table.confirm_del_patient')}: ${patient.PatientName}?`)
        if (confirm) {
            let response = await doctorApi.deletePatient(patient.UserStorageID)
            if (response) {
                let UserStorageID = patient.UserStorageID
                await this.props.deletePatient(UserStorageID)
            }
        }
    }

    blockPatient = async (patient) => {
        let {t} = this.props
        let response = await doctorApi.blockPatient(patient.UserStorageID)
        if (response) {
            let UserStorageID = patient.UserStorageID
            await this.props.setPatientLockedStatus(UserStorageID)
        }
    }

    editPatientDetails = (patient) => {
        history.push({
            pathname: `/dashboard/Patient`,
            state: {
                patient,
                from: {
                    fromPath: `/dashboard`,
                }
            },
        })
    }

    onRowClick = (rowInfo) => {
        history.push({
            pathname: `/dashboard/Patient`,
            state: {
                rowInfo,
                completed: false,
                from: {
                    fromPath: `/dashboard`,
                }
            },
        })
    }

    setPatientMoreFunctions = () => {
        let {t} = this.props
        return [
        /*    {
                name: 'Edit details',
                display: t('hcp.patient.table.edit_details'),
                call: (row => this.editPatientDetails(row))
            },*/
            {
                name: 'Delete patient',
                display: t('hcp.patient.table.del_patient'),
                call: (row => this.deletePatient(row))
            } ,{
                name: 'Lock Patient',
                display: t('hcp.patient.table.block_patient'),
                call: (row => this.blockPatient(row))
            },{
                name: 'Unlock Patient',
                display: t('hcp.patient.table.unblock_patient'),
                call: (row => this.blockPatient(row))
            }
        ]
    }
    onFilterDataSelected = (filter) => {
/*
        this.props.filterPatientsTable(Object.keys(filter)[0], Object.values(filter)[0])
*/
    }
    getFields = (t) => {
        return [
            {accessor: 'PatientName', Header: t('doctor.table.PatientName'),width: 300, makeFilter: false, resizable: false,Cell: ({original}) => {
                    return (
                        <div onClick={e => {
                            e.stopPropagation();
                            this.onRowClick(original)
                        }} style={{/*fontWeight:'550',*/cursor: 'pointer', width: 'fit-content',fontSize:'18px'}}>
                            {original.PatientName}
                        </div>
                    );
                }},
            {accessor: 'ID', Header: t('doctor.table.ID'), resizable: false,Cell: ({original}) => {
                    return (
                        <label style={{fontSize:'18px'}}>{original.ID}</label>
                    );
                }},
            {accessor: 'Gender', Header: t('doctor.table.Gender'),width: 100, resizable: false,Cell: ({original}) => {
                    return (
                        <label style={{fontSize:'18px'}}>{original.Gender}</label>
                    );
                } },
            {accessor: 'Age', Header: t('doctor.table.Age'),width: 100, resizable: false,Cell: ({original}) => {
                    return (
                        <label style={{fontSize:'18px'}}>{original.Age}</label>
                    );
                }},
            {accessor: 'LastVisit', Header: t('doctor.table.LastVisit'), width: 150, resizable: false,Cell: ({original}) => {
                    return (
                        <label style={{fontSize:'18px'}}>{original.LastVisit}</label>
                    );
                }},
            {accessor: 'CannabisPatient', Header: t('patient_boarding.cannabis_patient'), width: 150, resizable: false,Cell: ({original}) => {
                    return (
                        original.CannabisPatient==="Y"&&
                        <SvGraphics svgname={'check-icon'} style={{width:'20px',height:'20px'}}/>
                    );
                }},
            {accessor: 'Indication', Header: t('doctor.table.Indication'), width: 250,resizable: false,Cell: ({original}) => {
                    return (
                        <label style={{fontSize:'18px'}}>{original.Indication}</label>
                    );
                }},
            {accessor: 'MonthlyDose', Header: t('doctor.table.MonthlyDose'), width: 150, resizable: false,Cell: ({original}) => {
                    return (
                        <label style={{fontSize:'18px'}}>{original.MonthlyDose}</label>
                    );
                }},
            {accessor: 'PrescriptionValidity', Header: t('doctor.table.PrescriptionValidity'), width: 150, resizable: false,style: {color: 'red',fontSize:'18px'}},
            {accessor: 'Status', Header: t('doctor.table.Status'), resizable: false},
            {accessor: 'Enabled', Header: t('doctor.table.Locked'), resizable: false,Cell: ({ original }) => {
                    if (original.Enabled === 1){
                        return ''
                    } return (<SvGraphics svgname={'check-icon'} style={{width:'20px',height:'20px'}}/>)
                }}
/*            {accessor: 'Warning', Header: ' ', resizable: false
                ,Cell: ({ original }) => {
                    return (
                <div>
{/!*
                    <SvGraphics width={"15%"} height={"45%"} svgname={'warning-yellow'}/>
*!/}
{/!*
                    <SvGraphics width={"15%"} height={"45%"} svgname={'warning-red'}/>
*!/}

                </div>
                    )
                }},*/

                    /*if (original['PrescriptionValidity'] === '01/01/2021')
                        return (
                            <div>
                                <SvGraphics width={"15%"} height={"45%"} svgname={'warning-yellow'}/>

                                <AiFillWarning size={30} color={'red'}/>  <span className="sr-only">(current)</span>
                            </div>
                        );
                    if (original['PrescriptionValidity'] === '01/03/2019')
                        return (
                            <div>
                                <SvGraphics width={"15%"} height={"45%"} svgname={'warning-yellow'}/>

                                <AiFillWarning size={30} color={'orange'}/>  <span className="sr-only">(current)</span>

                            </div>
                        );
                    if (original['PrescriptionValidity'] === '01/01/2024')
                        return (
                            <div>
                                <SvGraphics width={"15%"} height={"45%"} svgname={'warning-yellow'}/>

                                <AiFillWarning size={30} color={'green'}/>  <span className="sr-only">(current)</span>
                            </div>
                        );*/



        ]
    }

    async componentDidMount() {
       /* let patients = await doctorApi.getAllPatients()
        if (patients) await this.props.setPatientsData(patients.data)*/
    }

    changeIsMore = () => {
        let val = !this.state.isMore
        this.setState({isMore: val} );
    }

    render() {
        let {t} = this.props
        let AllowedFields = this.getFields(t)
        let {entry,isSideBarOpen} = this.state
        return (
            <div className={'boxes'}>
                <div className={'context-area'}>
                    <MyTable
                        data={this.props.patientsData}
                        initialData={/*this.props.initiateVersionData*/[]}
                        columns={AllowedFields}
                        onSelectionChange={selected => this.onSelectionChange(selected)}
                        onFilterDataSelected={filter => this.onFilterDataSelected(filter)}
                        moreFunctions={this.setPatientMoreFunctions()}
                        hasMore={true}
                        hasSelection={false}
                        hasShowInfo={false}
                    />
                </div>
         {/*       <div className={'buttonBox'}>
                    <button className={'button6'} onClick={this.changeIsMore} > {t('doctor.show_more')} </button>
                </div>*/}
            </div>
        )
    }
}
//
function mapDispatchToProps(dispatch) {
    return {
        setPatientsData: patients => dispatch(setPatientsData(patients)),
        deletePatient: patientData => dispatch(deletePatient(patientData)),
        editPatientData: patientData => dispatch(editPatientData(patientData)),
        setPatientLockedStatus: patientData => dispatch(setPatientLockedStatus(patientData)),
        filterPatientsTable: (type, payload) => dispatch(filterPatientsTable(type, payload)),


    };
}
const mapStateToProps = state => {
    return {
        patientsData:state.patientsTableDataReducer.patientsData,
        initiatePatientsData:state.patientsTableDataReducer.initiatePatientsData
    };
};
//

const PatientTable = compose(
    withTranslation(),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(PatientTableComposed);

export default PatientTable;
